module.exports = __webpack_public_path__ + "static/media/headerlogo.f077da7c.PNG";